var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"plus-minus-effect"},[_c('span',{class:_vm.classStyle,style:({ transform: _vm.isToggled ? 'rotate(90deg)' : '' })}),_c('span',{class:_vm.classStyle,style:({ left: _vm.isToggled ? '50%' : '25%', right: _vm.isToggled ? '50%' : '25%', transform: _vm.isToggled ? 'translateY(-50%)' : '' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }